import { createContext, useContext } from 'react'

const Context = createContext()

export const SelectProvider = Context.Provider

export const useSelectData = () => useContext(Context)
